import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $stateParams, $filter, $timeout, $modal, LocaleService, submissionViewModel, StateUtils, ModalService, ViewModelService, QuoteService, PolicyService, PropertyCodeLookupService) {

				var ctrl = Object.create(BaseCtrl);
				var submissionVM = submissionViewModel();
				var chosenQuoteId = StateUtils.activeDataForState(true).chosenQuote;
				// $scope.disableForm = false;

				// DEF0932-GHC-Portal-In CCEW.js in the code $scope.employee = ViewModelService.create
				$scope.emodView = ViewModelService.create({}, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');

				ctrl.init = function () {

								//$scope.disableRisk = false;
								$scope.disableNext = false;
								$scope.disablePrevious = false;
								$scope.wordIcon = true;
								$scope.submissionVM = submissionVM;
								$scope.jobNumber = $stateParams.jobNumber;

								$scope.stateErrors = {
												riskId: { status: false, riskButton: false, message: 'Current Risk ID data not found. Click on Add Risk ID.' },
												missingClass: { status: false }
								};

								/*QuoteService.getEmodValues().then(
        		(datas) => {
        			console.log(datas);
        				});*/

								$scope.newEmod = {
												emodType: ''
								};

								$scope.emodView = ViewModelService.create($scope.newEmod, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
								//console.log($scope.emodView.emodType.aspects.availableValues);
								$scope.emodValue = $scope.emodView.emodType.aspects.availableValues;

								$scope.emodTypeView = {
												aspects: {
																inputCtrlType: "typelist",
																required: false,
																availableValues: $scope.emodView.emodType,
																visible: true,
																get validationMessages() {
																				return ['This is a required field'];
																}
												},
												value: ''

								};

								//getting per capitas
								QuoteService.getPerCapitaCodes().then(function (datas) {
												$scope.perCapitaClasses = [];
												if (datas.length > 0) {
																angular.forEach(datas, function (data) {
																				$scope.perCapitaClasses.push(data.classCode);
																});
												}
								});
				};

				ctrl.checkCoveredEmployees = function () {
								if ($scope.submissionVM.value.baseData.mSFCoveredEmployees_EXT.length > 0) $scope.stateErrors.missingClass = { status: false };else $scope.stateErrors.missingClass = { status: true };
				};
				//service to check risk id availability
				$scope.$watch('submissionVM.value.baseData.mSFRiskId', function (newVal) {
								console.log(newVal);
								if (newVal != null && newVal != undefined) {
												if (newVal.length != 9 || newVal.match(/^[0-9]+$/) == null) {
																$scope.stateErrors.riskId.riskButton = false;
																$scope.stateErrors.riskId.status = true;
																$scope.stateErrors.riskId.message = 'Risk ID must be numeric and length of 9 digits.';
												} else {
																QuoteService.getRiskIdByNumber(newVal).then(function (data) {
																				if (data == true) $scope.stateErrors.riskId.status = false;else {
																								$scope.stateErrors.riskId.riskButton = true;
																								$scope.stateErrors.riskId.status = true;
																								$scope.stateErrors.riskId.message = 'Current Risk ID data not found. Click on Add Risk ID.';
																				}
																});
												}
								}
				});

				//showing modal dialog box
				ctrl.setCancelState = function (mSFRiskId, mSFDate, emodnum) {

								$scope.riskIdMsf = mSFRiskId;

								$scope.stateErrors = {
												riskId: { status: false, riskButton: false, message: 'Current Risk ID data not found. Click on Add Risk ID.' },
												validRisk: { status: false, message: 'not a valid risk Id' },
												missingClass: { status: false },
												emodNumber: { status: false, message: "Emod (x.xx): can have no more than 2 digits to the right of the decimal point." },
												emodRange: { status: false },
												riskDate: { status: true, message: "Date may not be past Date" }
								};

								$modal.open({
												templateUrl: 'risk-submit.html',
												windowClass: 'modal',
												scope: $scope,
												controller: function controller($modalInstance) {

																$scope.risk_validate = function (riskvalue) {

																				PolicyService.isValidRiskID(riskvalue).then(function (data) {

																								if (data == true) {
																												$scope.stateErrors.validRisk.status = false;
																												$scope.stateErrors.riskId.status = false;
																								} else {
																												$scope.stateErrors.riskId.status = false;
																												$scope.stateErrors.validRisk.status = true;
																												$scope.stateErrors.validRisk.message = 'is not a valid risk Id';
																												//$scope.stateErrors.riskId.message = 'Current Risk ID data not found. Click on Add Risk ID.';
																								}
																				});
																};

																//console.log($scope.jobNumber);
																$scope.Validate_risk = function (riskvalue) {
																				console.log(riskvalue);
																				if (riskvalue != null && riskvalue != undefined) {
																								if (riskvalue.length != 9 || riskvalue.match(/^[0-9]+$/) == null) {
																												$scope.stateErrors.validRisk.status = false;
																												$scope.stateErrors.riskId.status = true;
																												$scope.stateErrors.riskId.message = 'Risk ID must be numeric and length of 9 digits.';
																								} else {

																												PolicyService.isValidRiskID(riskvalue).then(function (data) {

																																if (data == true) {
																																				$scope.stateErrors.validRisk.status = false;
																																				$scope.stateErrors.riskId.status = false;
																																} else {
																																				$scope.stateErrors.riskId.status = false;
																																				$scope.stateErrors.validRisk.status = true;
																																				$scope.stateErrors.validRisk.message = 'not a valid risk Id';
																																				//$scope.stateErrors.riskId.message = 'Current Risk ID data not found. Click on Add Risk ID.';
																																}
																												});
																								}
																				}
																};

																$scope.$watch('submissionVM.baseData.mSFEREffectiveDate.value', function (newVal) {

																				//$scope.todayDate = new Date();

																				if (newVal != null && newVal != undefined) {
																								$scope.dateModel = $filter('date')(newVal, "MM-dd-yyyy");
																								//$scope.dateModel = new Date(newVal);

																								$scope.dayMode = $scope.dateModel.day;

																								$scope.monthMode = $scope.dateModel.month + 1;

																								$scope.yearMode = $scope.dateModel.year;

																								$scope.newDate = $scope.monthMode + '-' + $scope.dayMode + '-' + $scope.yearMode;
																								PolicyService.getCurrentDate().then(function (res) {
																												$scope.todayDate = res;
																												$scope.dateModel1 = $filter('date')($scope.todayDate, "MM-dd-yyyy").replace(/\b0/g, '');
																								});
																								//$scope.dateModel1 = $filter('date')($scope.todayDate, "MM-dd-yyyy").replace(/\b0/g, '');


																								if ($scope.newDate < $scope.dateModel1) {

																												$scope.stateErrors.riskDate.status = true;
																												$scope.stateErrors.riskDate.message = "Value must be a date in the future";
																								} else {
																												$scope.stateErrors.riskDate.status = false;
																								}
																				}
																});

																$scope.Validate_emod = function (emodDecNum) {

																				if (emodDecNum <= "0.25" || emodDecNum >= "5.00") {

																								$scope.stateErrors.emodRange.status = true;
																								$scope.stateErrors.emodRange.message = 'Emod (x.xx): should be between 0.25 and 5.00';
																				} else {
																								$scope.stateErrors.emodRange.status = false;
																								$scope.stateErrors.emodRange.message = '';
																				}

																				var entered_value = emodDecNum;
																				$scope.before_dot = entered_value.toString().split(".")[0]; ///before
																				if ($scope.before_dot) {
																								$scope.before_dot_len = $scope.before_dot.length;
																								console.log($scope.before_dot_len);
																								if ($scope.before_dot_len > 1) {

																												$scope.stateErrors.emodNumber.status = true;
																												$scope.stateErrors.emodRange.status = false;
																												$scope.stateErrors.emodNumber.message = 'Emod (x.xx): can have no more than 1 digits to the left of the decimal point.';
																								} else $scope.stateErrors.emodNumber.status = false;
																				}
																				$scope.after_dot = entered_value.toString().split(".")[1]; ///after
																				if ($scope.after_dot) {
																								$scope.after_dot_len = $scope.after_dot.length;
																								console.log($scope.after_dot_len);
																								if ($scope.after_dot_len > 2) {

																												$scope.stateErrors.emodNumber.status = true;
																												$scope.stateErrors.emodRange.status = false;
																												$scope.stateErrors.emodNumber.message = 'Emod (x.xx): can have no more than 2 digits to the right of the decimal point.';
																								} else $scope.stateErrors.emodNumber.status = false;
																				}
																};

																$scope.saveRiskValues = function (riskId, riskDate, emodNum, emodType) {

																				$scope.wordIcon = false;
																				$scope.dateModel = $filter('date')(riskDate, 'MM-dd-yyyy');

																				$scope.emodTypeCode = emodType.code;

																				PolicyService.getEmodValues(riskId, emodNum, $scope.emodTypeCode, $scope.dateModel);
																				{};

																				$modalInstance.dismiss('cancel');
																};

																$scope.cancel = function () {
																				$scope.wordIcon = true;
																				//	$scope.submissionVM.value.baseData.mSFRiskId = "";
																				$modalInstance.dismiss('cancel');
																};
												}

								});
				};

				$scope.emodTemplate = function () {

								$modal.open({
												templateUrl: 'emod-letterTemplate.html',
												windowClass: 'modal',
												scope: $scope,
												controller: function controller($modalInstance) {

																$scope.cancel = function () {
																				$scope.wordIcon = true;
																				//	$scope.submissionVM.value.baseData.mSFRiskId = "";
																				$modalInstance.dismiss('cancel');
																};
												}
								});
				};

				//remove risk id validation on selecting experience rating no
				$scope.$watch('submissionVM.value.baseData.mSFExperienceRating', function (newVal) {
								if (newVal === false) {
												$scope.wordIcon = true;
												$scope.stateErrors.riskId.status = false;
												//$scope.submissionVM.baseData.mSFEREffectiveDate.value = "";
												//$scope.submissionVM.value.baseData.mSFRiskId = "";
								}
				});

				ctrl.next = function (nextFn, form) {
								submissionVM.baseData.mSFIsStateCov_EXT.value = true;
								ctrl.checkCoveredEmployees();
								angular.forEach($scope.stateErrors, function (error) {
												if (error.status == true) {
																$scope.valid = false;
																return;
												} else {
																$scope.valid = true;
												}
								});
								if ($scope.valid && $scope.stateErrors.riskId.status == false) nextFn(submissionVM, form.valid);else {}
				};

				return ctrl.create($scope);
};
fn.$inject = ['$scope', '$stateParams', '$filter', '$timeout', '$modal', 'LocaleService', 'submissionViewModel', 'StateUtils', 'ModalService', 'ViewModelService', 'quoteService', 'PolicyService', 'qnb.PropertyCodeLookupService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/controllers/WCStateCoveragesCtrl.js
// module id = 1305
// module chunks = 0